module.exports = __webpack_public_path__ + "img/2.d6ab292d.jpg";